import {
  LIST_HOLIDAYS_REQUEST,
  LIST_HOLIDAYS_SUCCESS,
  LIST_HOLIDAYS_FAIL,
  CREATE_HOLIDAYS_REQUEST,
  CREATE_HOLIDAYS_SUCCESS,
  CREATE_HOLIDAYS_FAIL,
  DETAIL_HOLIDAYS_REQUEST,
  DETAIL_HOLIDAYS_SUCCESS,
  DETAIL_HOLIDAYS_FAIL,
  UPDATE_HOLIDAYS_REQUEST,
  UPDATE_HOLIDAYS_SUCCESS,
  UPDATE_HOLIDAYS_FAIL,
  DELETE_HOLIDAYS_REQUEST,
  DELETE_HOLIDAYS_SUCCESS,
  DELETE_HOLIDAYS_FAIL,
  RESET_HOLIDAYS
} from '../../constants/holidays'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  holidays: [],
  holiday: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listHolidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_HOLIDAYS_REQUEST:
      return { ...state, loading: true }
    case LIST_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        holidays: action.payload,
        pageable: action.pageable
      }
    case LIST_HOLIDAYS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_HOLIDAYS_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_HOLIDAYS_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_HOLIDAYS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_HOLIDAYS_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_HOLIDAYS_SUCCESS:
      return { ...state, loadingDetail: false, holiday: action.payload }
    case DETAIL_HOLIDAYS_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_HOLIDAYS_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_HOLIDAYS_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_HOLIDAYS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_HOLIDAYS_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_HOLIDAYS_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_HOLIDAYS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_HOLIDAYS:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listHolidaysReducer
